<template>
    <div >
        <div class="item-box">
            <span class="name">客户名称:</span>
            <span>{{data.company}}</span>
        </div>
        <div class="item-box">
            <span class="name">网址:</span>
            <span>{{data.domain}}</span>
        </div>
        <div class="item-box">
            <span class="name">提交日期:</span>
            <span>{{data.create_time}}</span>
        </div>
        <div class="item-box">
            <span class="name">内容:</span>
            <span>{{data.content}}</span>
        </div>
        <div class="item-box">
            <span class="name">图片:</span>
            <div class="img-box" @click="showImg('../../assets/logovue.png')">
                <template v-for="item in data.imgs">
                    <img :src="item.img_url" alt=""  style="margin-right: 15px" @click="handlePreview(item.img_url)">
                </template>
            </div>
        </div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
        <div class="button-box" style="margin-top: 30px">
            <a-button size="default" class="seachBtn" @click="onClose()" style="margin-right: 15px">返回</a-button>
        </div>
    </div>
</template>

<script>
    import API from "./api";
    export default {
        name: "FeedBackDetails",
        data() {
            return {
                data:[],
                previewVisible:false,
                previewImage:""
            }
        },
        mounted() {
            this.FeedbackDetails(this.$route.query.id)
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/FeedBack"; //设置左侧导航2-2 active
        },
        methods: {
            FeedbackDetails(id) {
                let _that=this
                API.feedback.GET_DETAILS_DATA(id).then(res => {
                    console.log(res)
                    this.data = res.data.data.info;
                    console.log(this.data)
                })
            },
            handlePreview(src) {
                this.previewImage = src;
                this.previewVisible = true;
            },
            handleCancel() {
                this.previewVisible = false;
            },
            onClose(){
                this.$router.push({path: '/CustomerManagement/FeedBack'})
            },
        }
    }
</script>

<style scoped>
    .item-box{display: flex;align-items: center;margin-bottom: 20px;}
    .item-box .name{width: 60px;text-align: right;margin-right: 10px;flex: 0 0 60px;align-self: start;}
    .item-box span:nth-of-type(2){word-break: break-all;}
    .img-box{cursor: pointer;}
    .img-box img{width: 200px;}
</style>
